import { get } from "lodash";
import { http } from "../../../utils/axios/axios";

export const getFullRegionList = async (): Promise<any> => {
  const response = await http.get(`/configs/global-region`, {
    headers: {},
    params: {
      namespace: "defalut",
      group: "pruforce.Global",
    },
  });
  return get(response, "data.content.fullRegionList");
};

export const getRecruitPublicConfig = async (): Promise<any> => {
  const response = await http.get(`/configs/recruitment-public`, {
    headers: {},
    params: {
      namespace: "defalut",
      group: "pruforce.Recruitment",
    },
  });
  return get(response, "data.content");
};
